import Reveal from "@/components/Reveal";
import { FilePlus2, ScanLine, GitCompare, SlidersHorizontal } from "lucide-react";

const pillars = [
  { icon: FilePlus2, label: "Create" },
  { icon: ScanLine, label: "Validate" },
  { icon: GitCompare, label: "Compare" },
  { icon: SlidersHorizontal, label: "Profile" },
];

export default function CoreValue() {
  return (
    <section data-testid="core-value-section" className="py-24 md:py-32 bg-[#121316] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-6">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-300 font-mono">One workflow</p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight leading-tight">
              Create, validate, compare, and profile ADAC XML — without switching tools.
            </h2>
            <p className="mt-5 text-lg text-zinc-400 leading-relaxed">
              WebADAC brings the entire ADAC lifecycle into a single platform that understands the schema.
              Producers build compliant files and check them before delivery. Reviewers validate incoming
              submissions against the same standard. Everyone works from one source of truth.
            </p>
          </Reveal>

          <div className="lg:col-span-6 grid grid-cols-2 gap-4">
            {pillars.map((p, i) => (
              <Reveal
                key={p.label}
                delay={i * 0.08}
                className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-8 hover:border-zinc-600 transition-colors"
              >
                <span className="h-11 w-11 grid place-items-center bg-[#0033A0] rounded-sm">
                  <p.icon size={22} strokeWidth={1.6} />
                </span>
                <p className="mt-5 font-heading text-lg font-medium">{p.label}</p>
                <p className="mt-1 text-sm text-zinc-500 font-mono">ADAC XML</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
